import ReactTooltip from 'react-tooltip';

export default ({
  dataTip,
  dataEvent,
  dataFor,
  dataMultiline,
  style,
  globalEventOff,
  location,
  effect,
  iconStyle = undefined,
  tooltipIcon = 'fas fa-question-circle',
  toolTipClicked
}) => (
  <span className="icon has-text-info cove-productcard-icon">
    {toolTipClicked ? (
      <a style={style || { lineHeight: '16px' }} onClick={toolTipClicked}>
        <span className="icon">
          <i className={`${tooltipIcon}`} style={iconStyle} />
        </span>
      </a>
    ) : (
      <a
        data-tip={dataTip}
        data-event={dataEvent || 'click'}
        data-for={'toolTipDataGroup'} // data-for is a form grouping for all tooltips on a page
        data-multiline={dataMultiline || 'true'}
        style={style || { lineHeight: '16px' }}
      >
        <span className="icon">
          <i className={`${tooltipIcon}`} style={iconStyle} />
        </span>
      </a>
    )}

    <ReactTooltip
      id={'toolTipDataGroup'}
      globalEventOff={globalEventOff || 'click'}
      place={location || 'top'}
      effect={effect || 'solid'}
      className="tool-tip"
    />
  </span>
);
